import Button from '@ab-core/button';
import { formatPrice } from '@ab-core/functions';
import type { CableSnap } from '@ab-core/graphql/dist/index';
import { usePositionPriceObject } from '@ab-core/hooks-v2';
import { useActiveCart } from '@ab-core/hooks/cartNew/getCarts';
import AddLineItem from '@ab-core/hooks/cartNew/LineItems/addToCart/addToCart';
import Skeletonloader from '@ab-core/skeletonloader';
import { productStore } from '@ab-core/store';
import { TableDataItem, TableRow } from '@ab-core/table';
import { toast } from '@ab-core/toast';
import type { FC } from 'react';
import React, { useEffect } from 'react';

type CableSnapTableDataRowType = {
    cableSnapData: CableSnap;
    setModalLoading: (loading: boolean) => void;
};

export const CableSnapTableDataRow: FC<CableSnapTableDataRowType> = (props) => {
    const { cableSnapData, setModalLoading } = props;
    const cableSnapsSku = productStore.getters.useCableSnapSku();

    const { positionPriceObject } = usePositionPriceObject({
        productId: cableSnapsSku,
        quantity: cableSnapData.length,
        chargeNr: cableSnapData.chargeNr
    });

    const { activeCart } = useActiveCart();
    const { addLineItem, success, pending, response } = AddLineItem(activeCart?.id || '');

    const handleAddToCart = () => {
        if (!activeCart) {
            return;
        }

        if (!cableSnapsSku) {
            return;
        }

        if (!cableSnapData) {
            return;
        }

        setModalLoading(true);

        const fields = [];

        fields.push({
            name: 'lineitem-chargeNr',
            value: cableSnapData.chargeNr?.toString() || '0'
        });

        addLineItem({
            variables: {
                cartIds: activeCart?.id,
                lineItemInput: [
                    {
                        fields,
                        quantity: cableSnapData.length || 0,
                        sku: cableSnapsSku || 0,
                        id: undefined
                    }
                ]
            }
        });
    };

    useEffect(() => {
        if (success) {
            toast.success('Artikel wurde in den Warenkorb gelegt.');
            setModalLoading(false);

            productStore.setters.setShowCableSnap(false);
        }
    }, [response, success]);

    return (
        <TableRow>
            <TableDataItem>{cableSnapData.length}m</TableDataItem>
            <TableDataItem>
                {positionPriceObject?.value ? formatPrice(positionPriceObject.value) : <Skeletonloader />}
            </TableDataItem>
            <TableDataItem className="flex-justify-content-end">
                <Button onClick={handleAddToCart} disabled={pending}>
                    In den Warenkorb
                </Button>
            </TableDataItem>
        </TableRow>
    );
};
